"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var LockBodyScroll = function LockBodyScroll() {
  return /*#__PURE__*/_reactDom["default"].createPortal( /*#__PURE__*/_react["default"].createElement("style", {
    type: "text/css"
  }, "body { overflow: hidden !important; }"), document.head);
};

var _default = LockBodyScroll;
exports["default"] = _default;
//# sourceMappingURL=LockBodyScroll.js.map